var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{directives:[{name:"show",rawName:"v-show",value:(_vm.activate === true),expression:"activate === true"}],ref:"timer",staticClass:"count-down-timer"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.time_out === false),expression:"time_out === false"}],staticClass:"time_container",style:({
			textAlign: 'center',
			backgroundColor: _vm.setting.bg_color,
			paddingTop: '3px',
			paddingBottom: '3px',
			display: 'flex',
			justifyContent: 'center',
			alignItems: 'center',
			fontWeight: 'bold',
			fontSize: _vm.setting.font_size,		
		})},[(_vm.setting.card_type !== 'endUpCardSetting')?_c('section',{staticClass:"t_description",style:({
				marginRight: '0.3em',
				color: _vm.setting.description_color,
			})},[_vm._v(" "+_vm._s(_vm.setting.description)+" ")]):_c('section',{staticClass:"t_description",style:({
				marginRight: '0.3em',
				color: _vm.setting.timer_off_text_color,
			})},[_vm._v(" "+_vm._s(_vm.setting.timer_off_text)+" ")]),_c('section',{directives:[{name:"show",rawName:"v-show",value:(_vm.setting.card_type !== 'endUpCardSetting'),expression:"setting.card_type !== 'endUpCardSetting'"}],staticClass:"t_days",style:({
				textAlign: 'center',
				minWidth: '24px',
				color: _vm.setting.d_value_color,
			})},[_vm._v(" 00 ")]),_c('section',{directives:[{name:"show",rawName:"v-show",value:(_vm.setting.card_type !== 'endUpCardSetting'),expression:"setting.card_type !== 'endUpCardSetting'"}],staticClass:"t_days_unit",style:({
				color: _vm.setting.d_text_color,
			})},[_vm._v(" "+_vm._s(_vm.setting.d_text)+" ")]),_c('section',{directives:[{name:"show",rawName:"v-show",value:(_vm.setting.card_type !== 'endUpCardSetting'),expression:"setting.card_type !== 'endUpCardSetting'"}],staticClass:"t_hours",style:({
				textAlign: 'center',
				width: '24px',
				color: _vm.setting.h_value_color,
			})},[_vm._v(" 00 ")]),_c('section',{directives:[{name:"show",rawName:"v-show",value:(_vm.setting.card_type !== 'endUpCardSetting'),expression:"setting.card_type !== 'endUpCardSetting'"}],staticClass:"t_hours_unit",style:({
				marginRight: '0.3em',
				color: _vm.setting.h_text_color,
			})},[_vm._v(" "+_vm._s(_vm.setting.h_text)+" ")]),_c('section',{directives:[{name:"show",rawName:"v-show",value:(_vm.setting.card_type !== 'endUpCardSetting'),expression:"setting.card_type !== 'endUpCardSetting'"}],staticClass:"t_minutes",style:({
				textAlign: 'center',
				width: '23px',
				color: _vm.setting.m_value_color,
			})},[_vm._v(" 00 ")]),_c('section',{directives:[{name:"show",rawName:"v-show",value:(_vm.setting.card_type !== 'endUpCardSetting'),expression:"setting.card_type !== 'endUpCardSetting'"}],staticClass:"t_minutes_unit",style:({
				marginRight: '0.3em',
				color: _vm.setting.m_text_color,
			})},[_vm._v(" "+_vm._s(_vm.setting.m_text)+" ")]),_c('section',{directives:[{name:"show",rawName:"v-show",value:(_vm.setting.card_type !== 'endUpCardSetting'),expression:"setting.card_type !== 'endUpCardSetting'"}],staticClass:"t_seconds",style:({
				textAlign: 'center',
				width: '24px',
				color: _vm.setting.s_value_color,
			})},[_vm._v(" 00 ")]),_c('section',{directives:[{name:"show",rawName:"v-show",value:(_vm.setting.card_type !== 'endUpCardSetting'),expression:"setting.card_type !== 'endUpCardSetting'"}],staticClass:"t_seconds_unit",style:({
				color: _vm.setting.s_text_color,
			})},[_vm._v(" "+_vm._s(_vm.setting.s_text)+" ")]),_c('section',{directives:[{name:"show",rawName:"v-show",value:(_vm.setting.card_type !== 'endUpCardSetting'),expression:"setting.card_type !== 'endUpCardSetting'"}],staticClass:"t_description_end",style:({
				marginLeft: '0.3em',					
				color: _vm.setting.description_end_color,
			})},[_vm._v(" "+_vm._s(_vm.setting.description_end)+" ")])]),_c('div',{staticClass:"time_off_text",style:({
			textAlign: 'center',
			backgroundColor: _vm.setting.bg_color,
			paddingTop: '3px',
			paddingBottom: '3px',
			display: _vm.time_out === true && _vm.setting.end_at !== '' && _vm.setting.start_at !== '' ? 'flex' : 'none',
			justifyContent: 'center',
			alignItems: 'center',
			fontWeight: 'bold',
			fontSize: _vm.setting.font_size
		})},[_c('section',{staticClass:"t_off_text",style:({
				marginRight: '0.3em',
				color: _vm.setting.timer_off_text_color,
			})},[_vm._v(" "+_vm._s(_vm.setting.timer_off_text)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }